<template>
  <div class="search">
    <el-card>
      <el-row :gutter="10">
        <el-col :md="{span:10,offset:0}" :lg="{span:12,offset:0}" :xl="{span:15,offset:0}">
          <el-input class="input-area" v-model="input" placeholder="请输入内容" @keyup.enter.native="handleSearch"></el-input>
        </el-col>
        <el-col :md="{span:14,offset:0}" :lg="{span:12,offset:0}" :xl="{span:9,offset:0}">
          <el-button class="input-button" type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "search",
  data() {
    return {
      typeList: ["", "success", "info", "warning", "danger"],
      input: "",
    };
  },
  computed: {
    categoryList() {
      return this.$store.state.categoryList;
    },
    searchInputString() {
      return this.$store.state.searchInputString;
    },
  },
  created() {
    this.input = this.searchInputString;
  },
  methods: {
    handleSearch() {
      console.log(this.input);
      this.$store.commit("setSearchInputString", this.input);
      this.$store.commit("queryAllLinks");
      this.$store.commit("queryCategoryInfoList");
      this.$store.commit("queryArticleList", {
        categoryId: 0,
        page: 1,
        searchParam: this.searchInputString,
      });
    },
  },
};
</script>

<style scoped>
.input-button {
  width: 100%;
}

.input-button:focus {
  outline: 1px dotted;
}

.search {
  margin-right: 10px;
  margin-bottom: 10px;
}

.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>